import { APP_INITIALIZER, ApplicationConfig, ErrorHandler } from '@angular/core';
import { provideRouter, Router, UrlSerializer, withComponentInputBinding, withPreloading } from '@angular/router';
import { routes } from './app.routes';
import { IdlePreloadStrategy } from './shared/idle-preload.strategy';
import { provideClientHydration, withIncrementalHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { httpInterceptor } from './shared/interceptors/http.interceptor';
import { provideNativeDateAdapter } from '@angular/material/core';
import { IMAGE_CONFIG } from '@angular/common';
import * as Sentry from "@sentry/angular";
import { CustomUrlSerializer } from './serializers/custom-url-serializer';
import { VersionCheckService } from './shared/version-check.service';
import { MODAL_CONTENT_COMPONENT } from './shared/modal-content/modal-content.token';
import { ModalContentComponent } from './shared/modal-content/modal-content.component';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding(), withPreloading(IdlePreloadStrategy)),
    { provide: UrlSerializer, useClass: CustomUrlSerializer },
    provideClientHydration(withIncrementalHydration()),
    provideAnimations(),
    provideNativeDateAdapter(),
    {
      provide: IMAGE_CONFIG,
      useValue: {
        disableImageSizeWarning: true,
        disableImageLazyLoadWarning: true,
      }
    },
    provideHttpClient(
      withFetch(),
      withInterceptors([httpInterceptor])
    ),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => { },
      deps: [Sentry.TraceService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (versionCheck: VersionCheckService) => () => versionCheck.initialize(),
      deps: [VersionCheckService],
      multi: true,
    },
    // Supplies the modal host component to ModalContentService via DI so the
    // service doesn't statically import it — breaks a circular dependency.
    { provide: MODAL_CONTENT_COMPONENT, useValue: ModalContentComponent },
  ]
};
